import React from "react";
import classNames from "classnames";

import { Link } from "gatsby";
import { useDispatch } from "react-redux";
import { triggerContact } from "../../redux/appReducer";

/**
 * @param {string} title  Card title
 * @param {string} description   Card description
 * @param {background} background   Card background
 *
 * @return  {component}
 */

const CardBlog = (props) => {
  const { title, description, background, href, contact, tab } = props;

  const dispatch = useDispatch();

  const handleContact = () => {
    if (contact) dispatch(triggerContact());
  };

  const handleClick = (e) => {
    e.stopPropagation();
    handleContact();
  };

  const className = classNames(
    "cursor-pointer",
    "rounded-3xl",
    "bg-white",
    "relative",
    "text-lg"
  );

  const classNameBackground = classNames(
    "object-cover",
    "duration-500",
    "rounded-t-3xl",
    "h-[240px]",
    "w-full",
    "left-0",
    "top-0"
  );

  return (
    <div
      onClick={handleClick}
      className={
        className
      } /* data-aos="fade-zoom-in" data-aos-duration="1500" */
    >
      <Link to={href} target={tab ? "_blank" : ""}>
        <div>
          <img
            src={background}
            alt=""
            className={classNameBackground}
            loading="lazy"
          />
        </div>
        <div className="p-5">
          <div className="text-2xl font-medium">{title || "text-3xl"}</div>
          <div className="text-neutral-600 text-sm pt-2.5">
            {description || "text-3xl"}
          </div>
        </div>
      </Link>
    </div>
  );
};

export { CardBlog };
